// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_l4-6";
export var emphasizeQuantity = "_l4-3";
export var flatBottomCorners = "_l4-5";
export var productImage = "_l4-0";
export var quantityContainer = "_l4-2";
export var tooltip = "_l4-1";
export var wrapAndEllipsesOverflow = "_l4-4";